import React from 'react';
import classnames from 'classnames';
class Button extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, disabled, loading } = this.props;
            if (disabled || loading) {
                return;
            }
            onClick && onClick();
        };
    }
    render() {
        const { children, disabled, loading, style, className, size, type } = this.props;
        const btnCls = classnames('cfm_btn', `cfm_btn_${size}`, `cfm_btn_${type}`, {
            'cfm_btn_disabled': disabled || loading,
        }, className);
        return <button className={btnCls} style={style} disabled={disabled} onClick={this.handleClick}>
      {children}
    </button>;
    }
}
Button.defaultProps = {
    type: 'primary',
    size: 'md',
};
export default Button;



// WEBPACK FOOTER //
// ./components/button/index.tsx